<form *ngIf="fields && addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxItem)" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText [maxlength]="fields.name.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.descr.nullable}">{{ fields.descr.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="descr" pInputText [maxlength]="fields.descr.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.descr"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.order_index.nullable}">{{ fields.order_index.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="number" min="0" formControlName="order_index" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.order_index"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button
        class="k-generic-btn" type="submit" pButton icon="fa fa-check"
        label="{{dialogBoxItem.id ? ('common.edit' | translate) : ('common.add' | translate) }} {{ 'common.application' |translate }}">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/application/applicationForm.component.html